export const ReachProSolidLogo = ({
  width,
  height,
  color,
}: {
  width?: string | number;
  height?: string | number;
  color?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={width ?? 1832}
      zoomAndPan="magnify"
      viewBox="0 0 1374 1279.499967"
      height={height ?? 1706}
      preserveAspectRatio="xMidYMid meet"
      version="1.2"
      fill={color ?? '#221e1f'}
    >
      <path d="M 448.035156 0 C 432.667969 0.128906 418.125 6.988281 408.257812 18.761719 L 10.703125 497.15625 C 3.96875 505.203125 0.269531 515.367188 0.269531 525.863281 L 0.269531 1203.859375 C 0.269531 1243.554688 30.714844 1276.132812 69.53125 1279.507812 L 365.875 1279.507812 C 391.503906 1276.78125 411.46875 1255.097656 411.46875 1228.75 L 411.46875 210.667969 C 411.46875 210.667969 413.105469 155.429688 454.28125 150.613281 C 459.398438 150.011719 464.097656 149.722656 468.433594 149.722656 C 499.023438 149.722656 511.9375 163.976562 529.429688 183.917969 C 537.929688 193.59375 688.417969 366.316406 858.613281 561.660156 L 637.738281 810.851562 C 629.730469 819.878906 629.433594 833.375 637.019531 842.75 L 964.792969 1268.492188 C 969.867188 1274.773438 977.226562 1278.710938 985.171875 1279.5 L 1285.355469 1279.5 C 1306.796875 1278.261719 1342.171875 1268.484375 1365.042969 1222.351562 C 1370.152344 1212.054688 1372.691406 1201.960938 1373.519531 1192.421875 L 1373.519531 1177.929688 C 1371.402344 1152.789062 1358.96875 1133.585938 1355.289062 1128.398438 C 1354.707031 1127.578125 1354.128906 1126.847656 1353.46875 1126.089844 C 1337.90625 1108.214844 1097.558594 812.710938 880.285156 562.53125 L 1108.15625 305.441406 C 1123.359375 288.289062 1122.378906 262.199219 1105.925781 246.234375 L 867.738281 15.195312 C 857.691406 5.449219 844.238281 0 830.253906 0 C 830.105469 0 829.964844 0 829.8125 0 Z" />
    </svg>
  );
};
